<template>
	<div class="uk-width-expand@m">
		<div class="bb-options">
			<div class="bb-option">
				<p class="label">{{ wallbed.name }} Bed Mattresses: <InfoIcon slug="mattress-info" />
					<span class="sub-label">(Built by Serta Mattress Company)</span>
				</p>
				
				<div class="input-radios">
					<div class="input">
						<label><input type="radio" class="uk-radio" name="mattresses" :value="null" v-model="selected"> No Mattress</label>
					</div>
					<div class="input with-detail"
						v-for="(mattress,index) in mattresses"
						:key="mattress.id">
						<div class="uk-grid-collapse uk-flex uk-flex-middle" uk-grid>
							<div class="uk-width-2-3">
								<label>
									<input type="radio" class="uk-radio" name="mattresses" 
									:id="`mattress-${mattress.id}`"
									:value="index" v-model="selected">
								{{ mattress.name }} (+${{mattress.price.price}})</label>
							</div>
							<div class="uk-width-expand uk-text-right">
								<!-- Needs to have a unique toggle class/ID to open the correct one -->
								<a href="#" :uk-toggle="`target: #mattress-details-${mattress.id}`">See Details <i class="fas fa-angle-down"></i></a>
							</div>
						</div>
						<div class="details" hidden :id="`mattress-details-${mattress.id}`">
							<MattressDetails :details="mattress.description" />
						</div>
					</div>
				</div>
				<p class="bb-note"><span>NOTE:</span> CALIFORNIA RESIDENTS please call <a href="tel:866-877-7803">866-877-7803</a> to check mattress availability.</p>
			</div>
		</div>
		<NextButtons
      prev_route="right_cabinet"
      next_route="summary" />
	</div>
</template>

<script>
	import NextButtons from '../components/NextButtons.vue';
	import MattressDetails from '../components/MattressDetails.vue';
	import {mapState} from 'vuex';
	import InfoIcon from '../components/InfoIcon.vue';
	export default {
		name : 'mattress-view',
		components: {
			NextButtons,
			MattressDetails,
			InfoIcon
		},
		data(){
			return {
				selected: null
			}
		},
		mounted(){
			if(this.selected_mattress != null){
				setTimeout(() => document.getElementById(`mattress-${this.selected_mattress.id}`).click(),0);
			}
		},
		computed: {
			...mapState({
				wallbed : state => state.wallbed,
				mattresses :  state => state.mattresses,
				selected_mattress : state => state.selected_mattress
			})
		},
		watch : {
			selected(){
				if(this.selected != null) {
					this.$store.commit('setSelectedMattress',this.mattresses[this.selected]);
				}else{
					this.$store.commit('setSelectedMattress',null);
				}
			}
		}
	}
</script>